import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconRegularArchive = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0.959997 14.2863C0.959997 15.2327 1.60511 16 2.39999 16H12.96C13.7556 16 14.4 15.2327 14.4 14.2863V4.57042H0.959997V14.2863ZM4.79998 7.28604C4.79998 7.04967 4.96126 6.8574 5.16018 6.8574H10.1998C10.3979 6.8574 10.56 7.04967 10.56 7.28604V7.57092C10.56 7.80729 10.3987 7.99956 10.1998 7.99956H5.16094C5.06378 7.99724 4.97136 7.95086 4.90387 7.87055C4.83638 7.79023 4.79931 7.68252 4.80075 7.57092V7.28604H4.79998ZM14.4 0H0.959997C0.429311 0 0 0.510666 0 1.14216V2.85673C0 3.1716 0.215039 3.42826 0.479998 3.42826H14.88C15.0094 3.42501 15.1326 3.36311 15.2225 3.25606C15.3124 3.149 15.3618 3.00546 15.36 2.85673V1.14216C15.36 0.510666 14.9306 0 14.4 0Z",
		fill: "currentColor"
	})
});
export default SvgIconRegularArchive;
